import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { JackpotNormalizedGamesType } from '../../../types';
import { IInHouseJackpotsState, useInHouseJackpotsSelector } from '../../store';

const selectGames = (
  state: IInHouseJackpotsState
): JackpotNormalizedGamesType => prop('games')(state);

export const selectMissingGameIds = (launchGameIds: string[]) =>
  createSelector(selectGames, (games: JackpotNormalizedGamesType): string[] =>
    launchGameIds.filter((id) => !games[id])
  );

export const useGetMissingGameIds = (launchGameIds: string[]): string[] =>
  useInHouseJackpotsSelector(selectMissingGameIds, [launchGameIds], shallow);
